module.exports = __webpack_public_path__ + "static/media/logo_text.9034221a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo_text.svg
// module id = 2288
// module chunks = 0